import { render, staticRenderFns } from "./bulk-message-template-type-cards.vue?vue&type=template&id=ee52df28&scoped=true&"
import script from "./bulk-message-template-type-cards.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-type-cards.vue?vue&type=script&lang=js&"
import style0 from "./bulk-message-template-type-cards.vue?vue&type=style&index=0&id=ee52df28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee52df28",
  null
  
)

export default component.exports